export const MAX_BACKGROUND_SIZE = 20000
export const MAX_FILE_SIZE = 1024 * 1024 * 25
export const MAX_BACKGROUND_WIDTH = 1280
export const MAX_BACKGROUND_HEIGHT = 768
export const SUPPORTED_FILE_TYPES = {
  SKETCH: ['sketch'],
  NOTE: ['note'],
  CODE: ['code'],
  PDF: ['application/pdf'],
  IMAGES: [
    'image/bmp',
    'image/gif',
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/webp'
  ],
  VIDEOS: ['video/mp4', 'video/webm', 'video/quicktime'],
  AUDIOS: ['audio/mp3', 'audio/mpeg'],
  LINK: ['link']
}
export const PDF_WORKER =
  '//cdnjs.cloudflare.com/ajax/libs/pdf.js/2.12.313/pdf.worker.js'
export const CIRCUMFERENCE = 2 * Math.PI * 22

export default {
  MAX_BACKGROUND_SIZE,
  MAX_FILE_SIZE,
  MAX_BACKGROUND_WIDTH,
  MAX_BACKGROUND_HEIGHT,
  SUPPORTED_FILE_TYPES,
  PDF_WORKER,
  CIRCUMFERENCE
}
